import React, {
    useEffect, useState
} from 'react';
import { AccountsVService } from '../../../services/V2/gozer';
import { useHistory } from 'react-router-dom';
import { getOperatorId, handleError, isProd } from '../../Shared/Functions';
import { Button, CircularProgress } from '@mui/material';
import { withToast } from '../../Shared/Toast';
import ReCAPTCHA from "react-google-recaptcha";
import { CaptchaService } from '../../../services/V2/keymaster';
import { FindExistingAccount } from '../../Shared/FindExistingAccount';

const GuestPay = ({ errorToast }) => {
    const history = useHistory();
    const recaptchaRef: any = React.useRef();

    const [user, setUser] = useState<any>();
    const [findUser, setFindUser] = useState<any>({
        accountNumber: "",
        fullName: "",
        districtId: "",
        operatorId: ""
    });
    const [step, setStep] = useState<number>(0);
    const [operatorId, setOperatorId] = useState<string>("");
    const [ready, setReady] = useState<boolean>(false);
    const [setToken, setSetToken] = useState<any>();

    useEffect(() => {
        if(step === 0) {
            getOperatorId()
                .then((x:any) => {
                    setOperatorId(x ?? "")
                    setFindUser({
                        ...findUser,
                        operatorId: x
                    })
                    setReady(true)
                })
        } else if(step === 1) {
            findAccount()
        } else if(step === 2) {
            history.replace(`instaPay/${user.id}/GuestPay`)
        }
    }, [step])// eslint-disable-line react-hooks/exhaustive-deps

    const findAccount = async () => {
        var token = setToken;
        if(!setToken){
            await recaptchaRef?.current?.reset();
            token = await recaptchaRef?.current?.executeAsync();
            setSetToken(token)
        }
        CaptchaService.captchaValidate(token)
            .then(x => {
                if(x.success) {
                    AccountsVService.accountsVFindExistingBillingAccount(findUser)
                        .then(x => {
                            if(x === null) {
                                errorToast("No active billing account matched your search.")
                                setStep(0);
                                setSetToken(null);
                                setReady(true);
                                return;
                            }
                            setUser(x)
                            setReady(true)
                        })
                        .catch(err => {
                            err.message !=="Not Found" && errorToast(handleError(err))
                            setStep(0);
                            setSetToken(null);
                            setReady(true);
                        })
                } else {
                    errorToast("An error occurred validating the reCaptcha. Please refresh the page to try again. If errors persist, please contact support.")
                    setStep(0);
                    setSetToken(null);
                    setReady(true);
                }
            })

    }

    return (
        <form className="login-form" style={{ width: "100%" }}>
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={isProd() ? "6LdysiEhAAAAAPZwsLD0CCf4U8yJvrD6pkuGuTHw" : "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
            />
            {step === 0 &&
                <FindExistingAccount
                    findUser={findUser}
                    setFindUser={setFindUser}
                    operatorId={operatorId}
                />
            }
            {step === 1 ? ((ready) ?
                <div>
                    <p className="text-muted"><b>Confirm your account.</b></p>
                    <br />
                    <div><b>Account Number</b></div>
                    <div>{user?.accountNumber}</div>
                    <br />
                    <div><b>Name</b></div>
                    <div>{user?.customer?.fullName}</div>
                    <br />
                    <div><b>Address</b></div>
                    <div>{user?.customer?.street}</div>
                    <div>{user?.customer?.city}, {user?.customer?.state} {user?.customer?.zip}</div>
                </div>
                :
                <>
                    <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
                    <div>Searching for account...</div>
                </>) : null
            }
            <br />
            <Button variant="contained"
                style={{width: "100%"}}
                disabled={!ready}
                id="create"
                onClick={() => {
                    setReady(false);
                    setStep(step+1);
                }}
                color="primary"
                type="button">
                Continue
            </Button>
            <Button variant="outlined"
                style={{width: "100%", marginTop:"10px"}}
                id="cancel"
                onClick={() => history.push("/sign-in")}
                color="primary"
                type="button">
                    Cancel
            </Button>
        </form>)
}

export default withToast(GuestPay);
